export default __webpack_public_path__ + "static/media/loginBG.5c1eb279.png";